/** Normalize admin input to the existing SESSION_SIGNING_KEY_HEX wire contract. */
export const MIN_SIGNING_KEY_BYTES = 32;
export const MAX_SIGNING_KEY_BYTES = 1024;

export function signingKeyToHex(value, format = "hex") {
  if (typeof value !== "string" || !value) {
    throw new Error("Indica una clave de firma nueva");
  }

  if (format === "hex") {
    if (!/^[0-9a-fA-F]+$/.test(value) || value.length % 2 !== 0) {
      throw new Error("La clave hexadecimal debe contener pares de dígitos 0-9 y a-f");
    }
    if (value.length < MIN_SIGNING_KEY_BYTES * 2 || value.length > MAX_SIGNING_KEY_BYTES * 2) {
      throw new Error("La clave debe contener entre 32 y 1024 bytes");
    }
    return value.toLowerCase();
  }

  if (format === "utf8") {
    const bytes = new TextEncoder().encode(value);
    if (bytes.length < MIN_SIGNING_KEY_BYTES || bytes.length > MAX_SIGNING_KEY_BYTES) {
      throw new Error("La clave UTF-8 debe contener entre 32 y 1024 bytes codificados");
    }
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }

  throw new Error("Formato de clave no admitido");
}